import { useState } from 'react';

import { TCRM } from 'types/crm';

import { SettingsManager } from '@classes/settingsManager';
import { useFetchDataQuery } from '@hooks/useFetchDataQuery/useFetchDataQuery';

/**
 * Рабочее время текущей компании для календарей записи. Берётся собственный
 * график организации (`crm.schedule`); базовый шаблон должностей — запасной,
 * если своего графика у CRM нет. Повторно приходит из кэша запроса `getCRM`.
 */
export const useCompanyWorkSchedule = (enabled = true) => {
    const [crm, setCrm] = useState<TCRM>();
    const { crmID } = SettingsManager.getConnectionCredentials();

    const { isLoading } = useFetchDataQuery({
        getFnKey: 'getCRM',
        params: crmID,
        setDataList: setCrm,
        enabled,
    });

    return { schedule: crm?.schedule ?? crm?.basicScheduleTemplate, isLoading };
};
